import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import SbxElliotPage from './pages/SbxElliotPage';
import BolaoSbxPage from './pages/BolaoSbxPage';
import ThankYouPage from './pages/ThankYouPage';
import NotFoundPage from './pages/NotFoundPage';
import './App.css';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/sbx-e-elliot" element={<SbxElliotPage />} />
          <Route path="/bolao-sbx" element={<BolaoSbxPage />} />
          <Route path="/obrigado" element={<ThankYouPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
